import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from '../../../services/general/general.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['../../../../shared-styles/wallet.scss'],
})
export class WalletComponent implements OnInit, OnDestroy {
  public isMobile: any;
  public headerHeight: any = 0;
  public loading: any = false;
  public subscriptions: any = [];

  public labels = [
    {
      title: 'single-class',
      color: '#2bb3bc',
    },
    // {
    //   title: 'google-calendar',
    //   color: '#6f757b',
    // },
    // {
    //   title: 'test-class',
    //   color: '#8fc131',
    // },
    // {
    //   title: 'weekly-class',
    //   color: '#6481d9',
    // },
    // {
    //   title: 'group-class',
    //   color: '#d92828',
    // },
    {
      title: 'no-available-time',
      color: '#fba358',
    },
  ];
  public showLabels = false;

  constructor(
    public general: GeneralService,
    private cdRef: ChangeDetectorRef
  ) {
    this.isMobile = this.general.isMobile();
  }

  ngOnInit() {
    // if (environment.production) {
    //   this.general.showInfiniteWarning('web-under-construction');
    // }

    this.intializeSubscriptions();

    window.addEventListener('calendar-show-label', this);
    window.addEventListener('calendar-hide-label', this);
  }

  ngOnDestroy() {
    window.removeEventListener('calendar-show-label', this);
    window.removeEventListener('calendar-hide-label', this);

    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });
  }

  intializeSubscriptions() {
    this.subscriptions = [
      this.general.loading$.subscribe((res) => (this.loading = res)),
    ];
  }

  // Handle event Listener
  handleEvent(event: any) {
    switch (event.type) {
      case 'calendar-hide-label':
        this.showLabels = false;
        break;
      case 'calendar-show-label':
        this.showLabels = true;
        break;
    }
  }

  /**
   * =================== Sidebar ===================
   */
  onGetHeight(height: any) {
    if (height) {
      this.headerHeight = height;
    }
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
}
